import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RfqNameService {
  private rfqNameSubject = new BehaviorSubject<string>('');
  public rfqName$: Observable<string> = this.rfqNameSubject.asObservable();

  constructor() {}

  updateRfqName(name: string) {
    this.rfqNameSubject.next(name);
  }

  getCurrentRfqName(): string {
    return this.rfqNameSubject.getValue();
  }
} 